export enum PaginateSort {
  ASC = 'asc',
  DESC = 'desc',
}
